/* src/app/private/components/lead-fields-configurations/delete-lead-field/delete-lead-field.component.scss */
/*# sourceMappingURL=delete-lead-field.component.css.map */
